import { IOrder, IVariant, OrderItem } from '../types';

export const returnVariantLabel = (id: number, variants: IVariant[]) => {
  let variantLabel;
  for (let i = 0; i < variants.length; i++) {
    if (variants[i].id === id) {
      variantLabel = variants[i].name;
    }
  }
  return variantLabel;
};

export const isCompanyOrder = (order?: IOrder | null): boolean =>
  Boolean(order?.companyName || order?.companyOrder?.company?.name);

export const getOrderCompanyName = (order?: IOrder | null): string | null =>
  order?.companyName || order?.companyOrder?.company?.name || null;

/**
 * Resolves the display name for an order's "customer" slot. Company orders
 * (placed on behalf of a company rather than an individual) take precedence so
 * the company name is surfaced wherever a customer name would normally appear.
 */
export const getOrderCustomerName = (order?: IOrder | null): string => {
  if (!order) return '-';
  const companyName = getOrderCompanyName(order);
  if (companyName) return companyName;
  if (order.customer?.fullName) return order.customer.fullName;
  if (order.user) {
    const fullName = `${order.user.firstName ?? ''} ${
      order.user.lastName ?? ''
    }`.trim();
    if (fullName) return fullName;
  }
  return '-';
};

export const returnTimeStamps = (order: IOrder | null) => {
  if (!order) return [];
  const riderName = order.pilot?.user
    ? `${order.pilot.user.firstName} ${order.pilot.user.lastName} (Rider) assigned to order`
    : undefined;
  return [
    { title: 'Placed', value: order.timePlaced },
    { title: 'Payment Confirmed', value: order.timePaid },
    { title: 'Your order is being prepared', value: order.timePreparing },
    { title: 'Order prepared', value: order.timePrepared },
    { title: 'Order packed', value: order.timePrepared },
    { title: 'Order is ready for pickup', value: order.timeReady },
    {
      title: 'Order assigned to rider',
      value: order.timeAccepted,
      subtitle: riderName,
    },
    { title: 'Rider picked up order', value: order.timePickedUp },
    { title: 'Rider has arrived at your location', value: order.timeArrived },
    { title: 'Order delivered/Completed', value: order.timeDelivered },
  ];
};

export const calculateItemPrice = (order: OrderItem) => {
  const itemPrice = order.price;
  const options = order.options.map((o) => o.quantity * o.price);
  const optionPrice = options.reduce((acc, price) => acc + price, 0);

  const customizations = order.customisations.map((o) => o.quantity * o.price);
  const customizationPrice = customizations.reduce(
    (acc, price) => acc + price,
    0,
  );

  const customItemPrice = (itemPrice ?? 0) + optionPrice + customizationPrice;

  return customItemPrice * order.quantity;
};
